import { Users, Building2, UserCheck, AlertCircle } from "lucide-react";
import type { AccessKpis } from "../../../api/accessApi";

interface KpiCardsProps {
  kpis?: AccessKpis;
  isLoading: boolean;
}

export default function KpiCards({ kpis, isLoading }: KpiCardsProps) {
  if (isLoading) {
    return (
      <div className="kpi-grid">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="kpi-card">
            <div className="kpi-info" style={{ width: "60%" }}>
              <div className="skeleton" style={{ height: 12, width: "70%" }} />
              <div className="skeleton" style={{ height: 28, width: "40%", marginTop: 8 }} />
            </div>
            <div className="skeleton" style={{ width: 48, height: 48, borderRadius: 12 }} />
          </div>
        ))}
      </div>
    );
  }

  const cards = [
    {
      label: "Total Accounts",
      value: kpis?.total_accounts ?? 0,
      icon: <Users size={22} color="#6366F1" />,
      bg: "rgba(0, 102, 224, 0.12)",
    },
    {
      label: "Clients",
      value: kpis?.clients_count ?? 0,
      icon: <Building2 size={22} color="#3b82f6" />,
      bg: "rgba(59, 130, 246, 0.12)",
    },
    {
      label: "Analysts / Admins",
      value: kpis?.analysts_admins_count ?? 0,
      icon: <UserCheck size={22} color="#a855f7" />,
      bg: "rgba(168, 85, 247, 0.12)",
    },
    {
      label: "Suspended / Pending",
      value: kpis?.suspended_pending_count ?? 0,
      icon: <AlertCircle size={22} color="#f97316" />,
      bg: "rgba(249, 115, 22, 0.12)",
    },
  ];

  return (
    <div className="kpi-grid">
      {cards.map((card, idx) => (
        <div key={idx} className="kpi-card">
          <div className="kpi-info">
            <span className="kpi-label">{card.label}</span>
            <span className="kpi-value">{card.value}</span>
          </div>
          <div className="kpi-icon-wrap" style={{ background: card.bg }}>
            {card.icon}
          </div>
        </div>
      ))}
    </div>
  );
}
